export enum MethodDisputeEnum {
    open = 1,
    openClosed = 2,
    closedOpen = 3,
    closed = 4,
    dispenseWithSession = 5,
    notApplicable = 6,
}